import { makeStyles } from '@material-ui/core/styles';

const styles = (theme) => ({
  price: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column'
  },
  priceValue: {
    color: theme.colorPalette.white,
    lineHeight: 1.5
  },
  priceNote: {
    color: theme.colorPalette.beige_50_op_75,
    textAlign: 'center',
    textTransform: 'uppercase'
  },
  disabled: {
    color: theme.colorPalette.beige_50_op_13
  }
});

export default makeStyles(styles);
